
import {  Button, Step, StepLabel, Stepper } from "@mui/material";
import React, { useState } from "react";
import { BecomeSellerFormStep1 } from "./BecomeSellerFormStep1";
import { useFormik } from "formik";
import { BecomeSellerFormStep2 } from "./BecomeSellerFormStep2";
import { BecomeSellerFormStep3 } from "./BecomeSellerFormStep3";
import { BecomeSellerFormStep4 } from "./BecomeSellerFormStep4";
import * as Yup from "yup";
import { useAppDispatch } from "../../../State/Store";
import { createAccountSeller, fetchSellerProfile } from "../../../State/seller/sellerSlice";
import { Seller } from "../../../types/sellerType";
import { useNavigate } from "react-router-dom";
import { getIn, setIn } from "formik";
export const businessDetails= Yup.object().shape({
  businessName: Yup.string().required("Business Name is required"),
  businessMobile: Yup.string().required("Business Mobile is required"),
  businessAddress: Yup.string().required("Business Address is required"),
})
const steps = [
  "Tax Details & Mobile",
  "Pickup Address",
  "Bank Details",
  "Supplier Details",
];
const stepFields = [
  // step 0: Tax & Mobile
  ["mobile", "gstin"],
  // step 1: Pickup Address
  [
    "pickupAddress.streetName","pickupAddress.city","pickupAddress.region",
    "pickupAddress.country","pickupAddress.postalCode","pickupAddress.mobile"
  ],
  // step 2: Bank
  ["bankDetails.accountNumber","bankDetails.ifscCode","bankDetails.accountHolderName"],
  // step 3: Supplier Details
  ["sellerName","email","password","businessDetails.businessName","businessDetails.businessMobile","businessDetails.businessAddress"],
];
type Props ={
  setLocalError: React.Dispatch<React.SetStateAction<string | null>>;
  setSuccessMessage: React.Dispatch<React.SetStateAction<string | null>>;
}
export const finnishIBANRegex = /^FI\d{16}$/; // Starts with FI and followed by 16 digits
export const finnishIFSCRegex = /^[A-Z0-9]{4,11}$/;
const SellerAccountFormSchema = Yup.object().shape({
    mobile: Yup.string()
      .required("Mobile is required")
      .matches(/^[0-9]{9,15}$/, "Mobile number is not valid"),
    gstin: Yup.string().required("GSTIN is required"),
    sellerName: Yup.string().required("Seller Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().required("Password is required"),
    pickupAddress: Yup.object().shape({
      streetName: Yup.string().required("Street Name is required"),
      city: Yup.string().required("City is required"),
      region: Yup.string().required("Region is required"),
      country: Yup.string().required("Country is required"),
      postalCode: Yup.string()
        .required("Postal Code is required")
        .matches(/^\d{5}$/, "Postal Code is not valid"),
      mobile: Yup.string()
        .required("Mobile number is required")
        .matches(/^[0-9]{9,15}$/, "Mobile number is not valid"),
    }),
    bankDetails: Yup.object().shape({
      accountNumber: Yup.string()
      .required("Account Number is required")
      .matches(finnishIBANRegex, "Account Number must be a valid Finnish IBAN (e.g., FI followed by 16 digits)"),
    ifscCode: Yup.string()
      .required("IFSC Code is required")
      .matches(finnishIFSCRegex, "IFSC Code must be alphanumeric and meet Finnish requirements"),
      accountHolderName: Yup.string().required("Account Holder Name is required"),
    }),
    businessDetails:businessDetails,
    })
  
  


export const SellerAccountForm:React.FC<Props> = ({setLocalError,setSuccessMessage}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  const [activeStep, setActiveStep] = useState(0);
 
  const formik = useFormik({
    initialValues: {
        emailVerified:false,
        mobile: "",
        gstin: "",
        sellerName: "",
        email: "",
        password: "",
      pickupAddress: {
        city: "",
        country: "",
        mobile: "",
        postalCode: "",
        region: "",
        streetName: "",
      },
      bankDetails: {
        accountNumber: "",
        ifscCode: "",
        accountHolderName: "",
      },
      businessDetails: {
        businessName: "",
        businessMobile: "",
        businessAddress: "",
      },
    },
    validationSchema: SellerAccountFormSchema,
    onSubmit: async (values: Seller) => {
    
      try {
        console.log("Clicked");
        setLocalError(null)
        await dispatch(createAccountSeller(values)).unwrap();
  
        setSuccessMessage("Login Successfully, You will be redirected to home page")
        setTimeout(async() => {
          await dispatch(fetchSellerProfile()).unwrap();
         navigate("/seller"); // Navigate after 1 second
       }, 1500); // 1000ms delay
      } catch (error:any) {
        setLocalError(error.message || "An error occurred while creating the account.");
        setSuccessMessage(null)
        console.error("Error during account creation:", error);
      }
    },
  });

  
  const handleNext = async () => {
    const fields = stepFields[activeStep];
    const errors = await formik.validateForm();
  
    const hasError = fields.some((name) => !!getIn(errors, name));
    if (hasError) {
      let touched: any = {};
      for (const name of fields) {
        touched = setIn(touched, name, true);
      }
      formik.setTouched({ ...formik.touched, ...touched }, true);
      return;
    }
  
    if (activeStep === steps.length - 1) {
      await formik.submitForm();
    } else {
      setActiveStep((s) => s + 1);
    }
  };
  
  const handleBack = () => {
    setActiveStep((s) => s - 1);
  };
  
  return (
    <div className="">
      {/* Stepper */}
    
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
     
      {/* Render the form */}
      <form onSubmit={formik.handleSubmit} className="mt-20 space-y-10">
        {/* Render step-specific forms */}
        {activeStep === 0 && <BecomeSellerFormStep1 formik={formik} />}
        {activeStep === 1 && <BecomeSellerFormStep2 formik={formik} />}
        {activeStep === 2 && <BecomeSellerFormStep3 formik={formik} />}
        {activeStep === 3 && <BecomeSellerFormStep4 formik={formik} />}

        {/* Navigation buttons */}
        <div className="flex items-center justify-between ">
          {/* Back Button */}
          <Button
            onClick={handleBack}
            variant="contained"
            disabled={activeStep === 0} // Disable back button on the first step
          >
            Back
          </Button>

          {/* Continue or Submit Button */}
          <Button
             type="button"
            onClick={handleNext}
            variant="contained"
          >
            {activeStep === steps.length - 1 ? "Create Account" : "Continue"}
          </Button>
        </div>
      </form>
    </div>
  );
};
